module.exports = __webpack_public_path__ + "assets/img/body_bg.png?e84c3f8ba612bb20c2857833d4377161";